export default "__VITE_ASSET__0ab885bc__"